/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnaircoolingsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Return air cooling setpoint" |
*
* @param {Ahu_History_Key_Returnaircoolingsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnaircoolingsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Returnaircoolingsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnaircoolingsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid air reprise")
});
export { ahu_history_key_returnaircoolingsetpoint3 as "ahu_history_key_returnAirCoolingSetpoint" }